class UpcartProductWatcher {
  constructor(productIdsToWatch = []) {
    this.productIdsToWatch = productIdsToWatch;
    this.lastAppliedGiftVariant = null;
    this.attachCartHandlers();
  }

  attachCartHandlers() {

    // Override UpCart cart loaded handler
    window.upcartOnCartLoaded = (cart) => {
      this.handleCart(cart);
    };

  }

  handleCart(cart) {
    const foundItems = cart.items.filter((item) => this.productIdsToWatch.includes(item.product_id));
    const totalWatchedQuantity = foundItems.reduce((sum, item) => sum + item.quantity, 0);

    this.upcartEl = document.querySelector('#upCart');
    if (!this.upcartEl?.shadowRoot) return;

    this.barContainer = this.upcartEl.shadowRoot.querySelector('.upcart-rewards');
    if (!this.barContainer) return;

    this.rewardsMessage = this.barContainer.querySelector('.upcart-rewards-message');
    this.barProgress = this.barContainer.querySelector('.upcart-rewards-bar-foreground');
    this.tiers = this.barContainer.querySelectorAll('.upcart-rewards-tier');
    this.bar1 = this.tiers[0] || null;
    this.bar2 = this.tiers[1] || null;
    this.tierCircle1 = this.bar1?.querySelector(".upcart-rewards-tier-circle");
    this.icon1 = this.bar1?.querySelector(".upcart-rewards-tier-icon");
    this.tierCircle2 = this.bar2?.querySelector(".upcart-rewards-tier-circle");
    this.icon2 = this.bar2?.querySelector(".upcart-rewards-tier-icon");

    this.alwaysEnabled();

    if (foundItems.length > 0) {
      setTimeout(() => {
        this.controlBar(totalWatchedQuantity);
        this.updateGiftVariants(totalWatchedQuantity, cart);
      }, 300);
    } else {
      this.emptyItems();
      this.updateGiftVariants(0, cart);
    }
  }

  updateGiftVariants(items, cart) {
    const firstVariant = "47121144119529";
    const secondVariant = "47121144152297";

    console.log(cart);

    const autoGiftLineItems = cart.items.filter(
      (item) => item.properties?.upsell_origin === 'auto-gift'
    );

    // Determine which variant (if any) should be in the cart
    let variantToAdd = null;
    if (items === 1) {
      variantToAdd = firstVariant;
    } else if (items >= 2) {
      variantToAdd = secondVariant;
    }

    // Check if the correct variant is already in the cart
    const hasCorrectGift = autoGiftLineItems.some(item => item.variant_id == variantToAdd);

    // Prevent loop if correct item is already present and nothing to remove
    const hasOnlyCorrectGift =
      autoGiftLineItems.length === 1 &&
      autoGiftLineItems[0].variant_id == variantToAdd;

    if (hasOnlyCorrectGift || (!variantToAdd && autoGiftLineItems.length === 0)) {
      return; // ✅ No updates needed
    }

    // Remove incorrect gift items
    const itemsToRemove = autoGiftLineItems.filter(item => item.variant_id != variantToAdd);
    const removePromises = itemsToRemove.map(item =>
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      })
    );

    Promise.all(removePromises).then(() => {
      // Add the correct variant only if it's not already there
      if (variantToAdd && !hasCorrectGift) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantToAdd,
            quantity: 1,
            properties: {
              upsell_origin: 'auto-gift'
            }
          })
        }).then(() => {
          console.log("run twice?")
          this.lastAppliedGiftVariant = variantToAdd; // Save state
        });
      }else{
        window.upcartRefreshCart()
      }
    });
  }



  tierIcon(){
    return `<div class="upcart-rewards-tier-icon" style="width: 25px; height: 25px; margin: auto;"><svg viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.798 7.992c-.343-.756-1.098-1.242-1.928-1.242-1.173 0-2.119.954-2.119 2.122 0 1.171.95 2.128 2.125 2.128h.858c-.595.51-1.256.924-1.84 1.008-.41.058-.694.438-.635.848.058.41.438.695.848.636 1.11-.158 2.128-.919 2.803-1.53.121-.11.235-.217.341-.322.106.105.22.213.34.322.676.611 1.693 1.372 2.804 1.53.41.059.79-.226.848-.636.059-.41-.226-.79-.636-.848-.583-.084-1.244-.498-1.839-1.008h.858c1.176 0 2.125-.957 2.125-2.128 0-1.168-.946-2.122-2.119-2.122-.83 0-1.585.486-1.928 1.242l-.453.996-.453-.996Zm-.962 1.508h-.96c-.343 0-.625-.28-.625-.628 0-.344.28-.622.619-.622.242 0 .462.142.563.363l.403.887Zm3.79 0h-.96l.403-.887c.1-.221.32-.363.563-.363.34 0 .619.278.619.622 0 .347-.282.628-.625.628Z"></path><path fill-rule="evenodd" d="M2.499 6.75c0-1.519 1.231-2.75 2.75-2.75h9.5c1.519 0 2.75 1.231 2.75 2.75v2.945l.002.055c0 .018 0 .037-.002.055v3.445c0 1.519-1.231 2.75-2.75 2.75h-9.5c-1.519 0-2.75-1.231-2.75-2.75v-6.5Zm13.5 2.25h-1.248c-.414 0-.75.336-.75.75s.336.75.75.75h1.248v2.75c0 .69-.56 1.25-1.25 1.25h-4.748v-1c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-3.252c-.69 0-1.25-.56-1.25-1.25v-2.792c.292-.102.502-.38.502-.708 0-.327-.21-.606-.502-.708v-2.292c0-.69.56-1.25 1.25-1.25h3.252v.75c0 .414.336.75.75.75s.75-.336.75-.75v-.75h4.748c.69 0 1.25.56 1.25 1.25v2.25Z"></path></svg></div>`;
  }

  alwaysEnabled(){
    this.icon1.innerHTML = this.tierIcon();
    if(this.icon2){this.icon2.innerHTML = this.tierIcon();}
    
  }

  emptyItems(){
    if (this.rewardsMessage) { this.rewardsMessage.textContent = 'Add 1 OG Stash Box and get a FREE $25 Gift Card'; }
    if (this.barProgress) { this.barProgress.style.width = '0'; }
    if (this.tierCircle1) { this.tierCircle1.style.cssText = `border: 2px solid rgb(56, 155, 62); background-color: rgb(226, 226, 226); fill: rgb(56, 155, 62); `; }
    if (this.tierCircle2) { this.tierCircle2.style.cssText = `border: 2px solid rgb(56, 155, 62); background-color: rgb(226, 226, 226); fill: rgb(56, 155, 62); `; }
    
  }

  controlBar(items) {
    if (items == 1) {
      if (this.rewardsMessage) { this.rewardsMessage.textContent = 'Add 1 more OG Stash Box and get a FREE $50 Gift Card'; }
      if (this.barProgress) { this.barProgress.style.width = '50%'; }
      if (this.tierCircle1) { this.tierCircle1.style.cssText = `fill: rgb(226, 226, 226); background-color: rgb(56, 155, 62);`; }
      if (this.tierCircle2) { this.tierCircle2.style.cssText = `border: 2px solid rgb(56, 155, 62); background-color: rgb(226, 226, 226); fill: rgb(56, 155, 62); `; }
    }else if(items >= 2){
      if (this.rewardsMessage) { this.rewardsMessage.innerHTML = `<h4 > ✅ Deal UNLOCKED! </h4> <span> You've earned a $50 Gift Card on your order! </span>`; }
      if (this.barProgress) { this.barProgress.style.width = '100%'; }
      if (this.tierCircle2) { this.tierCircle2.style.cssText = `fill: rgb(226, 226, 226); background-color: rgb(56, 155, 62);`; }
    }
  }

}

new UpcartProductWatcher([7721556476137]);